var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"value":_vm.value,"items":_vm.reportsType,"chips":"","small-chips":"","item-text":"title","item-value":"name","label":_vm.$trans('v2.fm2.report.field.types')},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }